var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgClose2 = function SvgClose2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close2_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1200 1200",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".close2_svg__st0{fill:#606060}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "close2_svg__st0",
    d: "M600,51C297.3,51,51,297.3,51,600s246.3,549,549,549s549-246.3,549-549S902.7,51,600,51z M600,1116.4 c-284.7,0-516.4-231.7-516.4-516.4C83.6,315.3,315.3,83.6,600,83.6c284.7,0,516.4,231.6,516.4,516.4 C1116.4,884.7,884.7,1116.4,600,1116.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "close2_svg__st0",
    d: "M783.5,382.6L603.4,562.7c-6.4,6.4-16.7,6.4-23.1,0L400.2,382.6c-6.4-6.4-16.7-6.4-23.1,0v0 c-6.4,6.4-6.4,16.7,0,23.1l180.1,180.1c6.4,6.4,6.4,16.7,0,23.1L377.1,788.9c-6.4,6.4-6.4,16.7,0,23.1l0,0c6.4,6.4,16.7,6.4,23.1,0 l180.1-180.1c6.4-6.4,16.7-6.4,23.1,0L783.5,812c6.4,6.4,16.7,6.4,23.1,0l0,0c6.4-6.4,6.4-16.7,0-23.1L626.4,608.8 c-6.4-6.4-6.4-16.7,0-23.1l180.1-180.1c6.4-6.4,6.4-16.7,0-23.1v0C800.2,376.2,789.9,376.2,783.5,382.6z"
  })));
};
export default SvgClose2;